module.exports = __webpack_public_path__ + "media/images/novum-logo-white-5dd367fe789b45462a1213b79365474a.png";